import React from "react";
import InfoCollapse from "src/components/InfoCollapse/InfoCollapse";
import {
  SELF_ASSESSMENT_PROCESS,
  VALIDATION_PROCESS,
} from "../../constants/survey-tracks";

const EsgInfoCollapse = ({ track }) => {
  const steps =
    track === "self-assessment" ? SELF_ASSESSMENT_PROCESS : VALIDATION_PROCESS;

  return (
    <InfoCollapse title={"What is the assessment process?"}>
      <ul
        style={{
          fontSize: "16px",
        }}
      >
        {steps.map((step, i) => (
          <li
            className="mb-4"
            key={i}
          >
            {step}
          </li>
        ))}
      </ul>
    </InfoCollapse>
  );
};

export default EsgInfoCollapse;
